"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function () {
  var ownKeys = function (o) {
    ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return ownKeys(o);
  };
  return function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Portal = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const Portal = props => {
  const {
    children,
    modalId = 'modal',
    parentRef
  } = props;
  const modalRoot = (0, react_1.useMemo)(() => {
    const providedRoot = document.getElementById(modalId);
    if (providedRoot) {
      return providedRoot;
    }
    const root = document.createElement('div');
    root.setAttribute('id', modalId);
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', `${modalId}_label`);
    return root;
  }, [modalId]);
  react_1.default.useEffect(() => {
    const modalElement = modalRoot;
    if (parentRef) {
      modalElement.setAttribute('style', 'position: absolute;');
      parentRef.current?.append(modalElement);
    } else {
      document.body.append(modalRoot);
    }
    return () => {
      modalRoot?.remove();
    };
  }, [modalRoot, parentRef]);
  return (0, react_dom_1.createPortal)(children, modalRoot);
};
exports.Portal = Portal;